import React from 'react';
import Hero from '../components/Hero';
import Subscribe from '../components/Subscribe';

const Home = () => {
  return (
    <>
      <Hero />
      <Subscribe />
    </>
  );
};

export default Home; 